/* tslint:disable:jsx-no-lambda WI:47750 */
import * as React from 'react';
import {
    InfoBarMessageViewState,
    InfoBarMessageRank,
    InfoBarMessageSource,
} from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import shouldShowLargeAudienceMailTip from './shouldShowLargeAudienceMailTip';
import LargeAudienceMailtip from '../components/LargeAudienceMailtip';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import { RecipientMailtipInfoWithMembersCount } from '../components/LargeAudienceDetails';
import MailTipDetails from '../store/schema/MailTipDetails';
import { MailTipsCategory, MailTipsType } from '../datapoints';
import removeRecipientsAndLogMailTipsDatapoint from '../utils/removeRecipientsAndLogMailTipsDatapoint';

/**
 * returns InfoBarMessageViewState in case of large number of recipients.
 * returns null in case of small number of recipients.
 */
export default (
    largeAudienceInfos: MailTipDetails[],
    onRemoveRecipientsClick: (recipients: EmailAddressWrapper[]) => void
): InfoBarMessageViewState => {
    if (!largeAudienceInfos.length || !shouldShowLargeAudienceMailTip(largeAudienceInfos)) {
        return null;
    }

    const recipientsInfo: RecipientMailtipInfoWithMembersCount[] = largeAudienceInfos.map(
        largeAudienceInfo => ({
            recipient: largeAudienceInfo.recipient,
            totalMemberCount: largeAudienceInfo.count,
        })
    );

    return {
        key: 'LargeAudience',
        messageElement: (
            <LargeAudienceMailtip
                recipientsInfo={recipientsInfo}
                onRemoveRecipientClick={(recipient: EmailAddressWrapper) =>
                    removeRecipientsAndLogMailTipsDatapoint(
                        onRemoveRecipientsClick,
                        [recipient],
                        MailTipsCategory.LargeAudience,
                        MailTipsType.SingleRecipient,
                        1
                    )
                }
            />
        ),
        rank: InfoBarMessageRank.Info,
        source: InfoBarMessageSource.Compose,
    };
};
